import { Translator } from 'Translator';
import classnames from 'classnames';
import LocalizedNoIndexLink from 'components/LocalizedNoIndexLink';
import { MobileWrapperState } from 'modules/homescreen/hoc/mobileWrapper';
import React, { PureComponent } from 'react';

import MoreFiltersPopover from './MoreFiltersPopover';

const CSS = require('./MoreFiltersTrigger.less');

interface MoreFiltersTriggerProps extends Partial<MobileWrapperState> {
  selectedFilters: any[];
  isMobile: boolean;
}

interface MoreFiltersTriggerState {
  show: boolean;
}

class MoreFiltersTrigger extends PureComponent<
  MoreFiltersTriggerProps,
  MoreFiltersTriggerState
> {
  state = {
    show: false,
  };

  togglePopover = () => {
    this.setState({ show: !this.state.show });
  };

  closePopover = ({
    source,
    callback,
  }: {
    source: 'escape button' | 'outside click' | 'clear button' | 'apply button';
    callback: () => void;
  }) => {
    this.setState({ show: false }, callback);
  };

  renderPopover() {
    if (this.state.show) {
      return (
        <MoreFiltersPopover
          initialSelectedFilters={this.props.selectedFilters}
          onClose={this.closePopover}
        />
      );
    }
    return null;
  }

  render() {
    const filterOutFilters = [
      'adults',
      'children',
      'date.to',
      'date.from',
      'languages.items[]',
      'other.availability.items[]',
    ];
    const selectedFiltersToShow = this.props.selectedFilters.filter(
      (filter) => !filterOutFilters.includes(filter.uid),
    );

    const classes = classnames(CSS.FilterButton, {
      [CSS.FilterButtonHasValue]: selectedFiltersToShow.length > 0,
    });

    const length = selectedFiltersToShow.reduce(
      (acc, curr) => acc + (curr.value ? 1 : curr.subOptions.length),
      0,
    );
    const filtersTail = length ? `: ${length}` : '';

    return (
      <div>
        {this.props.isMobile && (
          <LocalizedNoIndexLink
            className={classes}
            to={{ pathname: '/filter/more/', state: { modal: true } }}
          >
            {`${Translator.translate(
              'SearchPage.SearchResults.filters',
              {},
              true,
              'Filters',
            )}${filtersTail}`}
          </LocalizedNoIndexLink>
        )}
        {!this.props.isMobile && (
          <button onClick={this.togglePopover} className={classes}>
            {`${Translator.translate(
              'SearchPage.SearchResults.filters',
              {},
              true,
              'Filters',
            )}${filtersTail}`}
          </button>
        )}
        {this.renderPopover()}
      </div>
    );
  }
}

export default MoreFiltersTrigger;
